export function ActitudSolidariaPresentation(props: { width: string }) {
	return (
		<iframe
			width={props.width}
			height="600"
			src="https://www.youtube.com/embed/2IIIsyvGtho"
			style={{ border: 0 }}
			title="YouTube video player"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			allowFullScreen
		></iframe>
	);
}
